import type { FC, ReactNode } from 'react'

import { Translation } from '@/components/i18n/Translation'

import './error.scss'

const Error: FC<{ children?: ReactNode; textId?: string }> = ({ textId, children }) => (
  <div className="feedback error">
    {textId && <Translation id={textId} />}

    {children}
  </div>
)

export default Error
